import _extends from '@babel/runtime-corejs3/helpers/extends';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import React__default, { forwardRef, useState, useRef } from 'react';
import styles from './4fdd7db686fe1e00140a295f31e559a6dc3d0352befbba98a5ca26820e04151c.cfe-internal.js';
import '../NewMenu/e398fde241b408541f8b3bf9184b188b740154e1018a3d02682e36abb8784c79.cfe-internal.js';
import '../LoadingSpinner/8d55022eb7dc98c5cad52af9b09720070c60d56c43c0dee35584cf8912401ad4.cfe-internal.js';
import QuickSearchInput from './86ee176382d6520ff20f6208bf390ccaf7315ce6595476992bcf34e60d399b3c.cfe-internal.js';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import useTranslation from '../../utils/Translation/de13cef5749fcd5a6a2788a56fd20c6a15d546ad2713851a9b628cd5aa481529.cfe-internal.js';
import Menu from '../NewMenu/Menu/3929114ebae6d44e7787ca01ba85af7a317e46913e7154eb644023bcc7f616b7.cfe-internal.js';
import mergeRefs from '../../utils/mergeRefs/836dcb860bec00d9c59bd64df8df6df42430840bc5bfc21b6000935baefbeacd.cfe-internal.js';
import LoadingSpinner from '../LoadingSpinner/b05dae0bfab7f74e168d22a1b9d6e2b06f09ee65c56c37161ee98465fe504ae4.cfe-internal.js';
import MenuItem from '../NewMenu/parts/e0e3eb84541b87de3d5450a4a2a9274df211ed818d3168ab6e8a7aeb42987979.cfe-internal.js';

var _excluded = ["maxHeight", "menuProps", "onSelect", "placement", "portalTarget", "zIndex", "isFlyoutFullWidth", "role"];
var QuickSearch = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _anchorRef$current;
  var externalMaxHeight = _ref.maxHeight,
    menuProps = _ref.menuProps,
    _onSelect = _ref.onSelect,
    placement = _ref.placement,
    portalTarget = _ref.portalTarget,
    zIndex = _ref.zIndex,
    _ref$isFlyoutFullWidt = _ref.isFlyoutFullWidth,
    isFlyoutFullWidth = _ref$isFlyoutFullWidt === void 0 ? false : _ref$isFlyoutFullWidt,
    role = _ref.role,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    items = _useState4[0],
    setItems = _useState4[1];
  var maxHeight = items.length > 10 ? 500 : undefined;
  var anchorRef = useRef(null);
  var anchorWidth = anchorRef === null || anchorRef === void 0 || (_anchorRef$current = anchorRef.current) === null || _anchorRef$current === void 0 ? void 0 : _anchorRef$current.clientWidth;
  var _useTranslation = useTranslation(),
    translate = _useTranslation.translate;
  return /*#__PURE__*/React__default.createElement(Menu, _extends({}, menuProps, {
    private_isFirstElementHighlightedOnUserActivatedOpen: false,
    private_isClosedMenuOpenedOnAnchorClick: false,
    maxHeight: externalMaxHeight === undefined ? maxHeight : externalMaxHeight,
    maxFlyoutWidth: isFlyoutFullWidth ? anchorWidth : undefined,
    placement: placement,
    portalTarget: portalTarget,
    zIndex: zIndex,
    anchor: /*#__PURE__*/React__default.createElement(QuickSearchInput, _extends({}, rest, {
      role: role !== null && role !== void 0 ? role : 'searchbox',
      ref: mergeRefs(ref, anchorRef),
      setIsLoading: setIsLoading,
      items: items,
      setItems: setItems
    }))
  }), isLoading ? /*#__PURE__*/React__default.createElement(LoadingSpinner, {
    size: "small",
    show: true,
    className: styles.loadingSpinner,
    "aria-label": translate('loading'),
    role: "menuitem"
  }) : _mapInstanceProperty(items).call(items, function (item, index) {
    var label = typeof item === 'string' ? item : item.label;
    var value = typeof item === 'string' ? item : item.value;
    return /*#__PURE__*/React__default.createElement(MenuItem, {
      key: index,
      value: value,
      onSelect: function onSelect() {
        return _onSelect === null || _onSelect === void 0 ? void 0 : _onSelect(item);
      }
    }, label);
  }));
});

export { QuickSearch as default };
